import 'react-native-gesture-handler';
import React , { useCallback } from 'react';
import * as eva from '@eva-design/eva';
import { ApplicationProvider, IconRegistry, Layout, Text, Button } from '@ui-kitten/components';
import { default as theme } from './theme.json'; // <-- Import app theme
import { default as mapping } from './mapping.json'; // <-- Import app mapping
import { useFonts } from 'expo-font';
import { EvaIconsPack } from '@ui-kitten/eva-icons';
import { AppNavigator } from './navigation.component';
import { I18nManager } from "react-native";
import { SafeAreaView } from 'react-native-safe-area-context';
import FlashMessage from "react-native-flash-message";
import { createStore, combineReducers} from 'redux';
import { Provider } from 'react-redux';
import loginReducer from './store/reducers/login'
import requestReducer from './store/reducers/request'
import newAddressReducer from './store/reducers/newAddress'
import dashboardReducer from './store/reducers/dashboard'
import { ThemeContext } from './theme-context';

export default function App() {
  const [themeMode, setThemeMode] = React.useState('light');

    const toggleTheme = () => {
      const nextTheme = themeMode === 'light' ? 'dark' : 'light';
      setThemeMode(nextTheme);
    };


  // FORCE RIGHT TO LEFT APP
  React.useEffect(()=>{
         I18nManager.forceRTL(true);
         I18nManager.allowRTL(true);
     },[])
     const rootReducer = combineReducers({
       login: loginReducer,
       newAddress: newAddressReducer,
       request: requestReducer,
       dashboard: dashboardReducer
     });
     const store = createStore(rootReducer);
     const [fontsLoaded] = useFonts({
      'IRANYekan': require('./assets/fonts/IRANYekanMobile.ttf'),
      'IRANYekanBold': require('./assets/fonts/IRANYekanMobile-Bold.ttf'),
    });
    if(!fontsLoaded){
      return null;
    }



  return(
  <Provider store={store}>
  <IconRegistry icons={EvaIconsPack} />
  <ThemeContext.Provider value={{ themeMode, toggleTheme }}>
  <ApplicationProvider
    {...eva} theme={{ ...eva[themeMode], ...theme }}
    customMapping={mapping}
     >

     <AppNavigator />

  </ApplicationProvider>
  </ThemeContext.Provider>

  <FlashMessage
   position="top"
   statusBarHeight={30}
   textStyle={{fontFamily:'IRANYekanBold'}}
   titleStyle={{fontFamily:'IRANYekanBold'}}
  />
  </Provider>
  );
}
